<template>
  <div v-if='showSideNav'
    class='background-style text-white py-4 px-4 lg:py-8 lg:px-12'
    :style='`${backgroundStyle}`'>
    <ul class='text-xs lg:text-lg mt-4 about-page flex flex-row lg:flex-col lg:sticky lg:top-32'>
      <li>
        <router-link :to='{ name: "Hotels" }'  class='py-2 pl-2 pr-2 uppercase opacity-90 flex flex-col-reverse lg:flex-row items-center justify-end lg:justify-start gap-y-2 lg:gap-y-0 lg:gap-x-2'>
          <img src='https://webconcert-public-assets.s3.ap-northeast-2.amazonaws.com/conferences/APSR2022/favicon-32x32.png' class='standard-transition opacity-50'>
          <span>Hotel Information</span>
        </router-link>
        <slot></slot>
      </li>
      <li>
        <router-link :to='{ name: "Tour" }' class='py-2 pl-2 pr-2 uppercase opacity-90 flex flex-col-reverse lg:flex-row items-center justify-end lg:justify-start gap-y-2 lg:gap-y-0 lg:gap-x-2'>
          <img src='https://webconcert-public-assets.s3.ap-northeast-2.amazonaws.com/conferences/APSR2022/favicon-32x32.png' class='standard-transition opacity-50'>
          <span>Tour Information</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HotelAndTourNavigation',
  data () {
    return {
      showSideNav: true,
    }
  },
  watch: {
    '$route.query.on_mobile_app': {
      handler: function (newVal) { 
        if (!newVal) {// show if the query param on_mobile_app does not exist
          this.showSideNav = true
        } else if (newVal !== 'true') {//  or show if string is not 'true'
          this.showSideNav = true
        } else {
          this.showSideNav = false
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters('events', [
      'eventMainThemeColor',
    ]),
    backgroundStyle () {
      return (this.customBackgroundStyle) ? this.customBackgroundStyle : `background-color: ${this.eventMainThemeColor};`
    }
  },

}
</script>

<style lang='scss' scoped>

.background-style {
  background: transparent; 
  width: 100%;
}

.about-page .router-link-active {
  @apply font-bold;
}

.about-page img {
  @apply w-px;
}

.about-page .router-link-active img,
.about-page a:hover img {
  @apply opacity-100 w-6;
}
  
@media (min-width: 1024px) {
  .background-style {
    width: 24rem;
    height: auto;
  }
}


</style>


